/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {
  createAdnHttpResource,
  createAdnHttpResourceAction,
  createAdnHttpResourceSender
} from '../../../util/create-adn-http-resource';
import {Uuid} from '../../../util/uuid';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the ConsentStatistic HTTP resource (factory product). */
export class ConsentStatisticResource {
}

/** Angular DI token for the SiteCountry HTTP resource (factory product). */
export class SiteCountryResource {
}

/** Angular DI token for the Site HTTP resource (factory product). */
export class SiteResource {
}

export function createConsentStatisticResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  return createAdnHttpResource(send, 'consentstatistic', () => localUserProfile, 'ConsentStatistic');
}

export function createSiteCountryResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  return createAdnHttpResource(send, 'sites/availablecountries', () => localUserProfile, 'SiteCountry');
}

export function createSiteResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const Site = createAdnHttpResource(send, 'sites', () => localUserProfile);
  const uri = ApiConfig.obtain().getVersionedUri('sites');

  Site.create = function(defaults: any) {
    return new Site(_.merge({
      id: Uuid.generate()
    }, defaults));
  };

  Site.adnCreativeSummary = createAdnHttpResourceAction(send, {
    method: 'GET',
    url: uri + '/:id/adncreativesummary'
  });

  Site.creativeSummary = createAdnHttpResourceAction(send, {
    method: 'GET',
    url: uri + '/:id/creativesummary',
    queryParams: ['summaryType']
  });

  return Site;
}

export const consentStatisticResourceProvider = {
  provide: ConsentStatisticResource,
  useFactory: createConsentStatisticResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

export const siteCountryResourceProvider = {
  provide: SiteCountryResource,
  useFactory: createSiteCountryResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

export const siteResourceProvider = {
  provide: SiteResource,
  useFactory: createSiteResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

